module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/tiktok-circle-640.5b488589ad0b6304.png"+" 640w",
        images: [{path: "https://static.sniffspot.com/packs/img/tiktok-circle-640.5b488589ad0b6304.png",width: 640,height: 640}],
        src: "https://static.sniffspot.com/packs/img/tiktok-circle-640.5b488589ad0b6304.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/tiktok-circle-640.5b488589ad0b6304.png"},
        
        width: 640,
        height: 640
      }